import React from 'react';
import Home from "../components/4-pages/Home"
import { User } from '../types';

const HomeContainer = (props: {user: User, logout: () => void}) => {
    return <Home userFirstName={props.user.firstName} logout={props.logout}/>
}

export default HomeContainer;